<template>
<div>
  <el-dialog title="服务申请" :visible.sync="dialogFormVisible" @close="cancelDialog" :close-on-click-modal="false">
    <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="120px" class="demo-dynamic">
      <el-form-item prop="useScenarios" label="服务事项" :rules="[{ required: true, message: '请选择您要申请的服务事项', trigger: ['blur','change'] }]">
        <!-- <el-input v-model="dynamicValidateForm.useScenarios" placeholder="请输入您要申请的服务事项"></el-input> -->
        <el-select v-model="dynamicValidateForm.useScenarios" placeholder="请选择您要申请的服务事项">
          <el-option :label="item.name" :value="item.name" v-for="(item, index) in list" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item prop="name" label="姓名" :rules="[{ required: true, message: '请输入申请人的姓名', trigger: 'blur' }]">
        <el-input v-model="dynamicValidateForm.name" readonly placeholder="请提供申请人的姓名"></el-input>
      </el-form-item>
      <el-form-item prop="phone" label="手机号" :rules="[{ required: true, message: '请输入联系电话', trigger: 'blur' }]">
        <el-input v-model="dynamicValidateForm.phone" readonly placeholder="顾问将于1-2个工作日内给您答复"></el-input>
      </el-form-item>

      <el-form-item prop="companyName" label="公司名称" :rules="[{ required: true, message: '请输入公司名称', trigger: 'blur' }]">
        <el-input v-model="dynamicValidateForm.companyName" readonly placeholder="请输入您要申请的企业名称"></el-input>
      </el-form-item> -->

      <el-form-item prop="demand" label="服务详情" :rules="[{ required: true, message: '请输入服务详情', trigger: 'blur' }]">
        <el-input type="textarea" :rows="4" v-model="dynamicValidateForm.demand" placeholder="请输入服务详情"></el-input>
      </el-form-item>
      <el-form-item>
        <div class="resetForm" @click="cancelDialog">取消</div>
        <div class="submitForm" @click="submitForm('dynamicValidateForm')">立即申请</div>
        <!-- <el-button type="primary" @click="submitForm('dynamicValidateForm')">提交</el-button>
        <el-button @click="resetForm('dynamicValidateForm')">重置</el-button> -->
      </el-form-item>
    </el-form>
    <img class="sc3" src="../assets/images/sc_3@2x.png">
  </el-dialog>
  <!--反馈弹窗-->
  <SmallDialog ref="smallDialog" tip="申请成功！" name="ServiceAdv"></SmallDialog>
</div>
</template>
<script>
  import {
    fetchAddNeed,
    fetchUserData
  } from '@/api/api'
  import SmallDialog from './smallDialog.vue'
  export default {
    data() {
      return {
        dialogFormVisible: false,
        dynamicValidateForm: {
          useScenarios: '',
          // name: '',
          // phone: '',
          // companyName: '',
          demand: ''
        },
        list:[
        {
          name: '工业互联网战略咨询服务',
        },
        {
          name: '软硬件集成服务',
        },
        {
          name: '实训基地及培训服务',
        },
        {
          name: '开放API服务'
        }
        ],
      };
    },
    components: {
      SmallDialog
    },
    watch: {
      dialogData: {
        handler() {
          this.dialogFormVisible = this.dialogData
          if(this.dialogFormVisible) {
            this.getUserData()
          }
        },
        immediate: true
      }
    },
    props: ['dialogData'],
    methods: {
      getUserData() {
        fetchUserData().then(res => {
          const {companyName, realname, nickName, phone} = res.data
          // this.dynamicValidateForm.companyName = companyName
          // this.dynamicValidateForm.name = realname
          // this.dynamicValidateForm.phone=phone
          if(!companyName || !realname || !nickName) {
            this.$message.error('请先完善信息')
            this.goAddInfo()
          }
        })
      },
      goAddInfo() {
        this.$router.push({
          name: 'PersonalData'
        })
      },
      cancelDialog() {
        this.resetForm('dynamicValidateForm')
        this.$emit('valueData', false)
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            fetchAddNeed(this.dynamicValidateForm).then(res => {
              if(res.code === 0) {
                this.$message.error(res.msg)
              }else {
                this.$refs.smallDialog.openDialog()
                this.$refs[formName].resetFields();
                this.$emit('valueData', false)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>
<style scoped>
  /deep/ .el-select {
    width: 100%;
  }

  /deep/ .el-dialog {
    width: 643px;
    height: 500px;
    background: #fff url('../assets/images/dialogBg@2x.png') top left no-repeat;
    background-size: 100%;
    padding-top: 30px;
    position: relative;
    border-radius: 15px;
    overflow: hidden;
  }

  .el-form-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  /deep/ .el-form-item__label {
    margin-left: 60px !important;
    width: 476px !important;
    text-align: left !important;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0A0909;
  }

  /deep/ .el-form-item__content {
    margin-left: 60px !important;
    width: 476px !important;
  }

  .submitForm {
    width: 220px;
    height: 45px;
    background: #0F5EFF;
    border-radius: 23px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 22px;
    text-align: center;
    line-height: 45px;
    margin-top: 30px;
    cursor: pointer;
  }

  .resetForm {
    width: 220px;
    height: 45px;
    background: #E8EDF6;
    border-radius: 23px;
    ont-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #A7AFC3;
    line-height: 22px;
    text-align: center;
    line-height: 45px;
    margin-top: 30px;
    cursor: pointer;
  }

  /deep/ .el-dialog__body {
    padding: 15px 20px
  }

  /deep/ .el-form-item__content {
    display: flex;
    justify-content: space-between;
  }

  /deep/ .el-input__inner {
    height: 45px;
  }

  /deep/ .el-dialog__header {
    width: 476px;
    margin: 0 auto;
  }

  /deep/ .el-dialog__title {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0A0909;
    line-height: 37px;
  }

  .sc3 {
    width: 100px;
    height: 48px;
    position: absolute;
    bottom: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/components/serviceDialog.vue